import { Editor, Transforms, Path, Range, Element } from 'slate';
import { randomString } from '../../../../../services/helpers/Helper';

export const createLinkNode = (code, text) => (
    {
        type: 'control',
        code: code,
        id: randomString(),
        children: [{ text }]
    }
)

export const insertLink = (editor, code, name) => {
    const { selection } = editor;
    const link = createLinkNode(code, name);
    if (!!selection) {
        const [parent, parentPath] = Editor.parent(editor, selection.focus.path);
        if (parent.type === 'control') {
            removeLink(editor);
        }

        //for image nodes, will be implemented later
        if (editor.isVoid(parent)) {
            Transforms.insertNodes(editor,
                { type: 'paragraph', children: [link] },
                {
                    at: Path.next(parentPath),
                    select: true
                }

            )
        }
        else if (Range.isCollapsed(selection)) {
            Transforms.insertNodes(editor, link, { select: true });
        }
        else {
            Transforms.wrapNodes(editor, link,
                { split: true }
            )

        }
    }
    else {
        Transforms.insertNodes(editor, { type: 'paragraph', children: [link] })
    }
};

export const removeLink = (editor) => {
    Transforms.unwrapNodes(editor, {
        match: n => !Editor.isEditor(n) && Element.isElement(n) && n.type === 'control'
    })
};